<!-- filename: WebForm.vue -->
<template>
  <div ref="form" :class="[{ 'webform-formkit': true, 'webform-formkit--loading': submissionLoading || loading }, `webform-formkit--${id}`]" @change="onChange">
    <!-- <div v-if="!loading && !success" class="kiw-form__progress">
      {{ progress }}
    </div> -->
    <FormKitSchema v-if="!loading && !success" :schema="schema" :data="formData" :library="cmpLibrary" />
    <div v-if="submissionLoading" class="webform-formkit__loader">
      <div class="kiw-form__loader kiw-form__loader--submission">
        <svg id="L9" version="1.1" class="icon-svg icon-svg--loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
          <title v-if="showTitle">name</title>
          <path fill="currentColor" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
          </path>
        </svg>
      </div>
    </div>
    <div v-if="success" class="webform-formkit__success">
      <h2 v-if="successTitle" class="webform-formkit__succes-title">
        {{ successTitle }}
      </h2>
      <div v-if="successMessage" class="webform-formkit__message" v-html="successMessage" />
    </div>
    <ul v-if="showErrorMessage" class="webform-formkit__errors">
      <li v-for="error in errorMessages" :key="error.path" v-html="error.message"></li>
    </ul>
  </div>
</template>

<script src="./Webform.js"></script>
